<template>
  <!--  -->
  <div
    class="modal fade"
    id="UploadStockModal"
    tabindex="-1"
    aria-labelledby="UploadStockModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="UploadStockModalLabel">Upload Stock</h5>
          <button
            type="button"
            class="close_modal_bt"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div v-if="!isLoading" class="modal-body">
          <form>
            <div class="mb-3">
              <label for="formFile" class="form-label"
                >Choose an Excel (.xlsx) or ODS file:</label
              >
              <input
                class="form-control"
                type="file"
                id="formFile"
                ref="fileInput"
                accept=".xlsx,.ods,.xls"
                @change="handleFileChange"
              />
              <div v-if="validationMessage" class="text-danger mt-2">
                {{ validationMessage }}
              </div>
            </div>
            <button
              class="btn btn-primary righter"
              @click="submitFile"
              :disabled="!isValidFile || isLoading"
            >
              Upload
            </button>
            <button
              type="button"
              class="mycustom-success-button neutral"
              @click="download__stock_template"
            >
              <i class="bi bi-plus-square-dotted"></i>
              <i class="bi bi-plus-circle-dotted"></i> Download_stocks_Template
            </button>
          </form>
        </div>
        <div class="modal-body" v-if="isLoading == true">
          <h3>Please wait for the upload to complete...</h3>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
</template>
<script>
import {
  generalApiUploadRequest,
  generalApiDownloadRequest,
} from "../../../api/apiIndex";
export default {
  data() {
    return {
      store: this.$route.params.storeLocation,
      validationMessage: "",
      selectedFile: null,
      isLoading: false, // Flag for upload in progress
    };
  },
  computed: {
    isValidFile() {
      return this.validationMessage === "" && this.selectedFile !== null;
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        this.validationMessage = "";
        this.selectedFile = null;
        return;
      }

      const allowedExtensions = [".xlsx", ".ods", ".xls"];
      const extension = file.name.slice(-4).toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        this.validationMessage = "Please select an Excel (.xlsx) or ODS file.";
        this.selectedFile = null;
      } else {
        this.validationMessage = "";
        this.selectedFile = file;
        // console.log(this.selectedFile);
      }
    },
    async submitFile() {
      if (!this.isValidFile) {
        return;
      }

      this.isLoading = true; // Set loading flag

      // Prepare data for upload (replace with your logic)
      var store = this.store;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("store_id", store);

      try {
        const response = await generalApiUploadRequest(
          "inventory/upload_stock/" + this.store,
          formData,
          1
        );
        if (response) {
          console.log("File uploaded successfully:", response);
          // window.location.reload();

          // Handle successful upload (e.g., clear form, show success message)
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Error uploading file:", error);
        // window.location.reload();

        // Handle upload error (e.g., show error message)
      } finally {
        this.isLoading = false; // Clear loading flag after upload attempt
        this.selectedFile = null; // Clear file selection
        window.location.reload();
      }
    },

    async download__stock_template() {
      const da_data = {};
      await generalApiDownloadRequest(
        "inventory/download_item_stock_template",
        "GET",
        da_data,
        "items_stock_tepmplate.xls",
        1
      );
    },
  },
};
</script>
